import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./ProtectedRoute.module.css";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const [expired, setExpired] = useState(false);
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");
  const expiry = localStorage.getItem("tokenExpiry");

  useEffect(() => {
    if (!expiry) return;

    const expiryTime = parseInt(expiry, 10);
    const remainingTime = expiryTime - Date.now();

    if (remainingTime <= 0) {
      setExpired(true);
      localStorage.clear();
      return;
    }

    const timer = setTimeout(() => {
      setExpired(true);
      localStorage.clear();
    }, remainingTime);

    return () => clearTimeout(timer);
  }, [expiry]);

  if (!token || !expiry) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Unauthorized Access</h2>
        <p className={styles.text}>No token found — please log in first.</p>
        <Link to="/login" className={styles.link}>
          Go to Login
        </Link>
      </div>
    );
  }

  if (expired) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Session Expired</h2>
        <p className={styles.text}>
          Your token has expired — please log in again.
        </p>
        <Link to="/login" className={styles.link}>
          Go to Login
        </Link>
      </div>
    );
  }

  let user = null;
  try {
    user = JSON.parse(storedUser);
  } catch {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Invalid User Data</h2>
        <p className={styles.text}>
          Corrupted user data detected — please log in again.
        </p>
        <Link to="/login" className={styles.link}>
          Go to Login
        </Link>
      </div>
    );
  }

  const role = user?.role?.trim();
  if (!role) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Role Missing</h2>
        <p className={styles.text}>
          User role not found — please log in again.
        </p>
        <Link to="/login" className={styles.link}>
          Go to Login
        </Link>
      </div>
    );
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Access Denied</h2>
        <p className={styles.text}>
          Your role is not permitted to view this page.
        </p>
        <Link to="/login" className={styles.link}>
          Return to Login
        </Link>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
